<div class="flex flex-col md:flex-row gap-8">
  <!-- Filtro -->
  <div class="w-full md:w-[30%] lg:w-[25%] p-4 md:ml-auto">
    <ui-filter (valueChange)="filter($event)" [vertical]="true" [fields]="[{
      name: '',
      selector: 'filter',
      content: [
        {
          component: 'TextComponent',
          selector: 'name',
          inputs: {
            placeHolder: 'Nome',
            default: '',
            value: '',
            type: Types.EInput.TEXT,
            required: false,
          },
        },
        {
          component: 'TextComponent',
          selector: 'lastName',
          inputs: {
            placeHolder: 'Sobrenome',
            default: '',
            value: '',
            type: Types.EInput.TEXT,
            required: false,
          },
        },
        {
          component: 'TextComponent',
          selector: 'birthDate',
          inputs: {
            placeHolder: 'Data de nascimento',
            default: '',
            type: Types.EInput.DATE,
            required: false,
          },
        },
      ],
    }]"></ui-filter>
  </div>

  <!-- Usuários -->
  <div class="flex-2 md:w-3/4 bg-gray-900 dark:bg-gray-800 p-6 rounded-lg shadow-md overflow-y-auto">
    <div *ngIf="users.length > 0; else noUsers" class="flex flex-wrap gap-4 justify-center md:justify-start">
      <ui-profile-card *ngFor="let user of users" [title]="user.name + ' ' + user.lastName"
      [clickable]="true"
      (clicked)="goToProfile(user.id)"
        [additionalInfo]="user?.birthDate ? (user?.birthDate! | relativeDate)! : 'Data de nascimento não preenchida.'" [subtitle]="user.lastName" [imageUrl]="user.avatar?.path"
        (action)="buttonPress($event, user)" [buttons]="[ 
          {icon: EIconType.Chat, type: EAlert.DARK, size: EComponentSize.Large, iconFill: false, name: 'chat'}
        ]">
      </ui-profile-card>
    </div>
    <div class="w-full flex justify-center align-center">
      <ui-pagination (refresh)="refresh($event)" (itemsPerPageChange)="itemsPerPageChange($event)" [current]="current" [total]="total"></ui-pagination>
    </div>
  </div>
</div>

<!-- Template 'Sem Usuários' -->
<ng-template #noUsers>
  <div class="flex flex-col items-center w-full justify-center text-center bg-gray-800 dark:bg-gray-700 text-gray-300 dark:text-gray-200 p-8 rounded-lg shadow-md">
    <ui-icon [icon]="EIconType.Search" [size]="EComponentSize.ExtraLarge" [color]="EAlert.DARK" [fill]="false"></ui-icon>
    <ui-label [tag]="ELabelType.PARAGRAPH" [type]="EAlert.DARK" ngClass="mt-4 text-lg font-semibold">Nenhum usuário encontrado</ui-label>
    <ui-label [tag]="ELabelType.PARAGRAPH" [type]="EAlert.DARK" ngClass="mt-2 text-sm">Tente ajustar os filtros.</ui-label>
  </div>
</ng-template>
